import { useEffect, useRef } from "react";

const GizmoWebWidget = () => {
  const popupRef = useRef(null);

  useEffect(() => {
    const accessionNumber = "ACN60620251430007";
    const userName = "WidgetRad";

    const widgetUrl = `http://localhost:3001/gizmo-widget?accession_number=${encodeURIComponent(
      accessionNumber
    )}&userName=${encodeURIComponent(userName)}`;

    const features =
      "width=360,height=330,toolbar=no,location=no,menubar=no,status=no,resizable=no,scrollbars=no";
    const popup = window.open(widgetUrl, "_blank", features);

    popupRef.current = popup;

    if (!popup) {
      console.error("Popup blocked");
      return;
    }

    // 🟡 Listen for resize messages
    const handleResize = (event) => {
      if (event.data?.type === "resize" && popup && !popup.closed) {
        const { width, height } = event.data;

        // 🟢 Adjust for browser window chrome (approximate offsets)
        const chromeWidth = 16;
        const chromeHeight = 80;

        popup.resizeTo(width + chromeWidth, height + chromeHeight);
      }
    };

    window.addEventListener("message", handleResize);

    return () => {
      window.removeEventListener("message", handleResize);
      if (popup && !popup.closed) {
        popup.close();
      }
    };
  }, []);

  return null;
};

export default GizmoWebWidget;
